import { html, LitElement } from "../vendor/lit-element/lit-element";
import { gsap } from "gsap";

class MortalityGlass extends LitElement {
  async firstUpdated() {
    // Give the browser a chance to paint
    await new Promise((r) => setTimeout(r, 0));

    const tl = gsap
      .timeline()
      .to(this, {
        opacity: 1,
      })
      .play();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 132.16 132.16"
    >
      <circle cx="66.08" cy="66.08" r="66.08" style="fill:#38a947" />
      <path
        d="M42.7,52.14a.13.13,0,0,0,.13.07h8.42a.38.38,0,0,1,.39.39v3.9a.41.41,0,0,1-.11.28.37.37,0,0,1-.28.11H35.77a.37.37,0,0,1-.28-.11.38.38,0,0,1-.12-.28V52.83a.68.68,0,0,1,.2-.49q2-1.85,5.25-5.31l2-2.08q3-3.11,3-4.52a2,2,0,0,0-.71-1.59,2.64,2.64,0,0,0-1.83-.62,2.57,2.57,0,0,0-1.81.62,2.1,2.1,0,0,0-.7,1.65v.79a.44.44,0,0,1-.11.29.41.41,0,0,1-.28.11H35.6a.41.41,0,0,1-.28-.11.44.44,0,0,1-.11-.29V39.63a5.74,5.74,0,0,1,1.22-3.23,7.07,7.07,0,0,1,2.87-2.13,10.31,10.31,0,0,1,4-.74,9.42,9.42,0,0,1,4.27.91,6.71,6.71,0,0,1,2.81,2.46,6.28,6.28,0,0,1,1,3.43,6.36,6.36,0,0,1-.66,2.74,13.75,13.75,0,0,1-2,2.93,30.31,30.31,0,0,1-2.08,2.28c-.77.77-1.83,1.8-3.2,3.1l-.66.63A.11.11,0,0,0,42.7,52.14Z"
        style="fill:#fff"
      />
      <path
        d="M55,56.28a3,3,0,0,1,0-4.14A2.82,2.82,0,0,1,57,51.35a2.77,2.77,0,0,1,2,.79,3.08,3.08,0,0,1,0,4.14,2.74,2.74,0,0,1-2,.81A2.8,2.8,0,0,1,55,56.28Z"
        style="fill:#fff"
      />
      <path
        d="M78.8,49.4a8.74,8.74,0,0,1-.59,3.17,7,7,0,0,1-2.86,3.28,8.5,8.5,0,0,1-4.6,1.24,8.68,8.68,0,0,1-4.59-1.2,7.05,7.05,0,0,1-2.87-3.29,9.27,9.27,0,0,1-.53-2v-.06c0-.24.14-.37.4-.37H68a.5.5,0,0,1,.46.33,1.59,1.59,0,0,0,.23.53,2.09,2.09,0,0,0,2,1.36,2.37,2.37,0,0,0,1.26-.35,2.45,2.45,0,0,0,.89-1,3.41,3.41,0,0,0,.36-1.65,3.51,3.51,0,0,0-.33-1.58,1.87,1.87,0,0,0-.77-.94,2.3,2.3,0,0,0-1.24-.35,2.91,2.91,0,0,0-1.42.36,1.89,1.89,0,0,0-.89.93.42.42,0,0,1-.43.33H63.19a.38.38,0,0,1-.28-.12.36.36,0,0,1-.11-.28V34.19a.37.37,0,0,1,.11-.28.38.38,0,0,1,.28-.12H77.65a.38.38,0,0,1,.28.12.41.41,0,0,1,.11.28v3.89a.39.39,0,0,1-.11.28.38.38,0,0,1-.28.12H68.44a.15.15,0,0,0-.17.16v3.87a.14.14,0,0,0,.07.13.1.1,0,0,0,.13,0,6,6,0,0,1,3.07-.79A7.3,7.3,0,0,1,75.67,43a6.74,6.74,0,0,1,2.57,3.23A9.59,9.59,0,0,1,78.8,49.4Z"
        style="fill:#fff"
      />
      <path
        d="M80.29,56.75a.34.34,0,0,1,.06-.35l5.28-7.95a.15.15,0,0,0,0-.2l-5.28-7.92a.46.46,0,0,1-.06-.23c0-.18.09-.27.29-.27h5a.51.51,0,0,1,.46.27L88.6,44c.05.07.09.1.13.1s.08,0,.1-.1l2.51-3.92a.52.52,0,0,1,.46-.27h5.38a.29.29,0,0,1,.3.15.37.37,0,0,1-.07.35l-5.28,7.92a.34.34,0,0,0,0,.2l5.28,7.95a.35.35,0,0,1,.07.23c0,.18-.1.26-.3.26H92.13a.51.51,0,0,1-.46-.26L89.16,52.7c0-.06,0-.1-.1-.1s-.08,0-.13.1l-2.51,3.93a.5.5,0,0,1-.46.26H80.58A.29.29,0,0,1,80.29,56.75Z"
        style="fill:#fff"
      />
      <path
        d="M27.73,80.55V67.23a.31.31,0,0,1,.34-.34h2.14a.42.42,0,0,1,.4.22l2.9,4.68a.08.08,0,0,0,.16,0l2.94-4.68a.42.42,0,0,1,.4-.22h2.14a.31.31,0,0,1,.34.34V80.55a.31.31,0,0,1-.34.34H37a.31.31,0,0,1-.34-.34V71.89c0-.12-.08-.14-.14,0l-2,3.3a.42.42,0,0,1-.4.22h-1a.42.42,0,0,1-.4-.22l-2-3.3c-.06-.1-.14-.08-.14,0v8.66a.31.31,0,0,1-.34.34H28.07A.31.31,0,0,1,27.73,80.55Z"
        style="fill:#fff"
      />
      <path
        d="M41.77,77.77a7.29,7.29,0,0,1-.28-2,7,7,0,0,1,.3-2.12,4.45,4.45,0,0,1,4.54-3.16,4.42,4.42,0,0,1,4.44,3.14,7,7,0,0,1,.3,2.1,8.09,8.09,0,0,1-.26,2,4.74,4.74,0,0,1-9,.06Zm6.3-.64a5.08,5.08,0,0,0,.16-1.4,5.67,5.67,0,0,0-.16-1.42,1.83,1.83,0,0,0-3.58,0,6.29,6.29,0,0,0,0,2.82,1.82,1.82,0,0,0,3.58,0Z"
        style="fill:#fff"
      />
      <path
        d="M59.07,70.71a.33.33,0,0,1,.18.42l-.38,2.1c0,.24-.16.26-.4.22a2.49,2.49,0,0,0-1,0,1.77,1.77,0,0,0-1.72,1.78v5.36a.31.31,0,0,1-.34.34H53.23a.31.31,0,0,1-.34-.34V71a.31.31,0,0,1,.34-.34h2.14a.31.31,0,0,1,.34.34v.62c0,.1.06.14.14.06A2.51,2.51,0,0,1,58,70.47,2.07,2.07,0,0,1,59.07,70.71Z"
        style="fill:#fff"
      />
      <path
        d="M66.23,72.87h-1.8a.11.11,0,0,0-.12.12v4.14c0,.86.34,1.28,1.14,1.28H66a.31.31,0,0,1,.34.34v1.72a.34.34,0,0,1-.34.36c-.38,0-.74,0-1.1,0-2,0-3.3-.48-3.32-2.64V73a.11.11,0,0,0-.12-.12h-1a.31.31,0,0,1-.34-.34V71a.31.31,0,0,1,.34-.34h1a.11.11,0,0,0,.12-.12V68.23a.31.31,0,0,1,.34-.34h2a.31.31,0,0,1,.34.34v2.26a.11.11,0,0,0,.12.12h1.8a.31.31,0,0,1,.34.34v1.58A.31.31,0,0,1,66.23,72.87Z"
        style="fill:#fff"
      />
      <path
        d="M76.87,73.87v6.68a.31.31,0,0,1-.34.34H74.39a.31.31,0,0,1-.34-.34v-.48c0-.1-.06-.12-.14,0a3.53,3.53,0,0,1-2.74,1c-2,0-3.42-.94-3.42-3s1.46-3.24,4.16-3.24h2a.12.12,0,0,0,.12-.12v-.42c0-.86-.54-1.4-1.6-1.4-.8,0-1.34.28-1.52.76a.35.35,0,0,1-.4.26l-2.22-.28c-.2,0-.34-.12-.32-.28.2-1.66,2-2.88,4.4-2.88C75,70.45,76.87,71.93,76.87,73.87Zm-2.82,3.44v-.7a.12.12,0,0,0-.12-.12H72.51c-1.2,0-1.94.46-1.94,1.3S71.15,79,72,79A1.85,1.85,0,0,0,74.05,77.31Z"
        style="fill:#fff"
      />
      <path
        d="M78.87,80.55V67.23a.31.31,0,0,1,.34-.34h2.14a.31.31,0,0,1,.34.34V80.55a.31.31,0,0,1-.34.34H79.21A.31.31,0,0,1,78.87,80.55Z"
        style="fill:#fff"
      />
      <path
        d="M83.65,68a1.72,1.72,0,1,1,1.72,1.68A1.62,1.62,0,0,1,83.65,68ZM84,80.55V71a.31.31,0,0,1,.34-.34h2.14a.31.31,0,0,1,.34.34v9.6a.31.31,0,0,1-.34.34H84.31A.31.31,0,0,1,84,80.55Z"
        style="fill:#fff"
      />
      <path
        d="M94.57,72.87h-1.8a.11.11,0,0,0-.12.12v4.14c0,.86.34,1.28,1.14,1.28h.56a.31.31,0,0,1,.34.34v1.72a.34.34,0,0,1-.34.36c-.38,0-.74,0-1.1,0-2,0-3.3-.48-3.32-2.64V73a.11.11,0,0,0-.12-.12h-1a.31.31,0,0,1-.34-.34V71a.31.31,0,0,1,.34-.34h1a.11.11,0,0,0,.12-.12V68.23a.31.31,0,0,1,.34-.34h2a.31.31,0,0,1,.34.34v2.26a.11.11,0,0,0,.12.12h1.8a.31.31,0,0,1,.34.34v1.58A.31.31,0,0,1,94.57,72.87Z"
        style="fill:#fff"
      />
      <path
        d="M96.41,84.53V82.89c0-.22,0-.34.12-.34h.12c1.58,0,2.22-.26,2.54-1.58a.22.22,0,0,0,0-.16L96,71c-.08-.22,0-.38.28-.38h2.3a.37.37,0,0,1,.38.28l1.64,6a.08.08,0,0,0,.16,0l1.56-5.94a.37.37,0,0,1,.38-.3H105c.24,0,.36.16.28.38l-3.42,10.28c-.92,2.68-1.66,3.6-5.14,3.6h-.14C96.47,84.87,96.41,84.75,96.41,84.53Z"
        style="fill:#fff"
      />
      <path
        d="M55.56,101.63,53.1,96.19a.15.15,0,0,0-.14-.1H51.14a.11.11,0,0,0-.12.12v5.34a.31.31,0,0,1-.34.34H48.54a.31.31,0,0,1-.34-.34V88.21a.31.31,0,0,1,.34-.34h5.62a4,4,0,0,1,4.28,4.22,3.73,3.73,0,0,1-2.56,3.72.1.1,0,0,0-.06.16l2.64,5.52c.12.22,0,.4-.24.4H56A.44.44,0,0,1,55.56,101.63ZM51,90.43v3.36a.12.12,0,0,0,.12.12h2.6a1.76,1.76,0,0,0,1.9-1.78,1.78,1.78,0,0,0-1.9-1.82h-2.6A.11.11,0,0,0,51,90.43Z"
        style="fill:#fff"
      />
      <path
        d="M60.14,89a1.72,1.72,0,1,1,1.72,1.68A1.62,1.62,0,0,1,60.14,89Zm.32,12.6V92a.31.31,0,0,1,.34-.34h2.14a.31.31,0,0,1,.34.34v9.6a.31.31,0,0,1-.34.34H60.8A.31.31,0,0,1,60.46,101.55Z"
        style="fill:#fff"
      />
      <path
        d="M65.18,99.05V99a.31.31,0,0,1,.34-.34h2c.22,0,.34,0,.34.12v.14c0,.58.7,1.06,1.7,1.06s1.52-.4,1.52-.94c0-.8-1.52-.78-3-1.38s-2.82-1.14-2.82-2.92c0-2,1.72-3.22,4.2-3.22s4.28,1.34,4.28,3.24c0,.14-.12.24-.34.24h-2c-.22,0-.34,0-.34-.12v-.12c0-.58-.6-1-1.62-1-.86,0-1.52.32-1.52.9,0,.8,1.4.86,2.88,1.32s3.08,1.16,3.08,3c0,2-1.76,3.14-4.34,3.14S65.18,100.79,65.18,99.05Z"
        style="fill:#fff"
      />
      <path
        d="M75.56,101.55V88.23a.31.31,0,0,1,.34-.34H78a.31.31,0,0,1,.34.34v6.6c0,.1.08.12.14,0l2.66-3.06a.56.56,0,0,1,.42-.2H84c.28,0,.4.18.22.42l-2.46,3.08a.15.15,0,0,0,0,.16l2.94,6.22a.26.26,0,0,1-.26.4H82.18a.41.41,0,0,1-.4-.26l-1.94-4.58c0-.1-.1-.08-.16,0l-1.24,1.58c0,.06-.06.08-.06.14v2.8a.31.31,0,0,1-.34.34H75.9A.31.31,0,0,1,75.56,101.55Z"
        style="fill:#fff"
      />
    </svg>`;
  }
}

customElements.define("mortality-glass-state", MortalityGlass);
